import { EditorProps } from 'react-data-grid'

import { memo, useEffect, useState } from 'react'

import { 
  DgtPdOrderPicklistExtraReturnItem, 
  DgtPdMovementReason 
} from '../models'

import { DataStore, SortDirection } from '@aws-amplify/datastore'

import { MovementType } from '../constants/EnumType';

export default memo(function SelectMvResCodeEditor({ props } : {
  props: EditorProps<DgtPdOrderPicklistExtraReturnItem | null>
}) {
  const { row, onRowChange } = props

  const [ movementReasons, setMovementReasons ] = useState<DgtPdMovementReason[]>([]);

  useEffect(() => {
    const getMovementReasons = async () => {
      const mvReas = await DataStore.query(
        DgtPdMovementReason, s => s
          .movementType("eq", MovementType.RETURN)
          .componenType('eq', row?.orderId?.startsWith('8') ? 'RM':'PK')
          .active('eq', true)
          ,{
            sort: s => s.reasonCode(SortDirection.ASCENDING)
          }
        )
      
      setMovementReasons(mvReas)
    }
    getMovementReasons()
  }, [ row ])

  return <div className='flex items-center justify-center w-full h-full'>
    <select title='select'
      value={row?.returnReasonCode || undefined}
      className='p-1 border border-gray-400 rounded-md'
      onChange={(e) => {
        let updatedRow = { 
          ...row, 
          returnReasonCode: e.currentTarget.value,
          returnReasonDescription: e.currentTarget.options[e.currentTarget.selectedIndex].text
        } as DgtPdOrderPicklistExtraReturnItem
        onRowChange(updatedRow, true)
      }}
      onKeyDown={(e) => e.stopPropagation()}
    >
      {movementReasons.map(rea => <option key={rea.id} value={rea.reasonCode}>{rea.reasonDesciption}</option>)}
    </select>
  </div>
})